// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav[data-v-5f326404]{position:fixed;width:100vw;z-index:10}.nav--customBg[data-v-5f326404]{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px)}.nav__btn[data-v-5f326404]{border-radius:10px}.nav__btn[data-v-5f326404]  .v-btn__content{font-size:1rem;line-height:1.4}.nav__title[data-v-5f326404]{font-weight:800;font-size:1rem;line-height:1.55}.nav__icon[data-v-5f326404]{height:16px;width:16px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
